import { render, staticRenderFns } from "./TableWrapper.vue?vue&type=template&id=a040f042"
import script from "./TableWrapper.vue?vue&type=script&lang=ts"
export * from "./TableWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports